import { render, staticRenderFns } from "./authorizationPopup.vue?vue&type=template&id=496dc52a&scoped=true"
import script from "./authorizationPopup.vue?vue&type=script&lang=js"
export * from "./authorizationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496dc52a",
  null
  
)

export default component.exports